import { render, staticRenderFns } from "./NeedsTable.vue?vue&type=template&id=bf6c7f9a&scoped=true&"
import script from "./NeedsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6c7f9a",
  null
  
)

export default component.exports